export default __webpack_public_path__ + "static/media/IMG0116.0767e34f.jpg";